import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, connect } from 'react-redux';
import { change } from 'redux-form';
import cx from 'classnames';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import BoxInput from '../../form/BoxInput';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Heading from '../../../common/heading/Heading';
import {
	NEXT,
	FEMALE,
	MALE,
	ONBOARDING_GENDER_TITLE,
	OTHER,
	RATHER_NOT_SAY,
} from '../../../../constants/Copy';
import {
	EVT_ONBOARDING_SUBMIT_GENDER,
	EVT_ONBOARDING_SKIP_GENDER,
} from '../../../../constants/EventTypes';
import { analyticsPush } from '../../../../actions/applicationActions';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';

import './RegisterGender.scss';

const GENDER = {
	FEMALE: {
		LABEL: FEMALE,
		VALUE: 'f',
	},
	MALE: {
		LABEL: MALE,
		VALUE: 'm',
	},
	UNSPECIFIED: {
		LABEL: OTHER,
		VALUE: 'u',
	},
};

let RegisterGender = ({ submitting, invalid, pristine, handleSubmit, gender }) => {
	const dispatch = useDispatch();

	const genderRadioInputsClassNames = cx(
		'onboarding__radio-inputs',
		'onboarding__radio-inputs--columns'
	);

	return (
		<form method="POST" onSubmit={handleFormSubmit} className="onboarding-gender-form">
			<OnboardingProgress activeStep={2} />
			<div className="onboarding-gender-form__main">
				<Heading className="onboarding-gender-form__title">{ONBOARDING_GENDER_TITLE}</Heading>

				<div className={genderRadioInputsClassNames}>
					<Field
						label={GENDER.MALE.LABEL}
						name="gender"
						type="radio"
						value={GENDER.MALE.VALUE}
						component={BoxInput}
						addFocusHandler
						id="gender-male"
						autoFocus
					/>
					<Field
						label={GENDER.FEMALE.LABEL}
						name="gender"
						type="radio"
						value={GENDER.FEMALE.VALUE}
						component={BoxInput}
						addFocusHandler
						id="gender-female"
					/>
					<Field
						label={GENDER.UNSPECIFIED.LABEL}
						name="gender"
						type="radio"
						value={GENDER.UNSPECIFIED.VALUE}
						component={BoxInput}
						addFocusHandler
						id="gender-unspecified"
					/>
				</div>

				<Button
					loading={submitting}
					disabled={invalid || pristine}
					testId="gender-button"
					type="submit"
				>
					{NEXT}
				</Button>
			</div>

			<div className="onboarding-nav-link">
				<a
					className="onboarding__link accent"
					onClick={() => setUnspecifiedGenderAndSkipPage()}
					role="button"
					tabIndex="0"
				>
					{RATHER_NOT_SAY}
				</a>
			</div>
		</form>
	);

	function handleFormSubmit(event) {
		event.preventDefault();
		const currentGender = Object.keys(GENDER).find((key) => GENDER[key].VALUE === gender);
		dispatch(analyticsPush({ label: GENDER[currentGender].LABEL }, EVT_ONBOARDING_SUBMIT_GENDER));
		handleSubmit();
	}

	function setUnspecifiedGenderAndSkipPage() {
		dispatch(change('register', 'gender', GENDER.UNSPECIFIED.VALUE));
		dispatch(analyticsPush({ label: RATHER_NOT_SAY }, EVT_ONBOARDING_SKIP_GENDER));
		setTimeout(() => handleSubmit(), 1); // Add timeout to simulate submitting of unspecified gender option with Redux Form
	}
};

RegisterGender.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
};

const validateGender = ({ gender }) => {
	if (!gender) {
		return { gender: true }; // No copy needed
	}
	return null;
};
RegisterGender = reduxForm({
	form: 'register',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: validateGender,
})(RegisterGender);

const selector = formValueSelector('register');

RegisterGender = connect((state) => {
	const gender = selector(state, 'gender');
	return {
		gender,
	};
})(RegisterGender);

export default RegisterGender;
